import Highcharts from 'highcharts';
Highcharts.setOptions({
	lang: {
		      decimalPoint: ','
	      }

});

export const figure12 = {
chart: {
zoomType: 'xy',
animation: false,
marginTop: 50,
marginLeft: 270,
plotBackgroundColor: null,
plotBorderWidth: null,
plotShadow: false,
type: 'bar',
height: '600px',
backgroundColor: 'rgba(255, 255, 255, 0.0)',
style: {
fontFamily: 'Montserrat'
}
},

colors: ['#ffc000', '#fff3cd','#ffd653'],

credits: {
enabled: false
},
title: {
text: null
},
subtitle: {
text: null
},

plotOptions: {
series: {
borderWidth: 0,
marker: {
symbol: 'circle',
enabled: false,
states: {
hover: {
enabled: true,
radius: 5
}
}
}
}
},

exporting: {
enabled: false
},

xAxis: [{
reversed: true,
categories: [ "Monde", "", "Asie centrale et Asie du Sud", "Afrique subsaharienne", "Amérique latine et Caraïbes", "Asie de l’Est et Asie du Sud-Est", "Océanie (à l’exception de l’Australie et de la Nouvelle-Zélande)", "Asie de l’Ouest et Afrique du Nord", "Amérique du Nord et Europe", "Australie et Nouvelle-Zélande" ],
lineColor: "#d7d7d7",
tickColor: "#d7d7d7",
tickLength: 16,
labels: {
style: {
fontWeight: 'normal',
color: '#999999',
fontSize: '12px'
}
},
}],
yAxis: [{
labels: {
format: '{value}',
style: {
fontWeight: 'normal',
color: '#999999',
fontSize: '12px'
},
},
max: 30,
min: 0,
tickInterval: 5,
gridLineWidth: 2,
title: {
text: '',
style: {
color: Highcharts.getOptions().colors[1]
}
}
}],
tooltip: {
shared: true,
useHTML: true,
hideDelay: 500,
backgroundColor: null,
borderWidth: 0,
shadow: false,
style: {
padding: 0
}
},
legend: {
enabled: false,
},

series: [      
{
name: '2000',
tooltip: {
valueSuffix: '%'
},
dataLabels: {
enabled: true,
formatter: function () {
     return Highcharts.numberFormat(this.y, 1);
},
style: {
     fontWeight: 'normal',
     textOutline: false,
     color: '#999999',
     fontSize: '10px'
}
},
data: [5.3, null, 3.3, 5.5, 6.8, 5.1, 4.5, 8.5, 8.6, 6.7],
},
{
name: '2012',
tooltip: {
valueSuffix: '%'
},
dataLabels: {
enabled: true,
style: {
     fontWeight: 'normal',
     textOutline: false,
     color: '#999999',
     fontSize: '10px'
}
},
data: [5.5, null, 2.9, 3.8, 7.4, 6.5, 9.3, 9.0, 10.4, 12.4],
},
{
name: '2022',
tooltip: {
valueSuffix: '%'
},
dataLabels: {
enabled: true,
style: {
fontWeight: 'normal',
textOutline: false,
color: '#999999',
fontSize: '10px'
}
},
data: [5.6, null, 2.9, 3.7, 8.6, 8.0, 13.9, 7.6, 9.8, 19.3],
},
]
}
